import { getPropAtPath } from './puckContentPath';
import { setBlockPropAtPath } from './siteBlocks';

const parseHtml = (html) => {
  const template = document.createElement('template');
  template.innerHTML = html;
  return template;
};
const anchors = (template, id) => Array.from(template.content.querySelectorAll('a[data-download-id]'))
  .filter((anchor) => anchor.getAttribute('data-download-id') === id);
const htmlSettings = (anchor) => {
  try { return JSON.parse(anchor?.getAttribute('data-download-form') || '{}'); } catch { return {}; }
};

export function collectDocumentSlots(props) {
  const slots = [];
  const walk = (value, path) => {
    if (typeof value === 'string' && value.includes('data-download-id')) {
      const seen = new Set();
      parseHtml(value).content.querySelectorAll('a[data-download-id]').forEach((anchor) => {
        const downloadId = anchor.getAttribute('data-download-id');
        if (!downloadId || seen.has(downloadId)) return;
        seen.add(downloadId);
        slots.push({ path, shape: 'downloadHtml', urlProp: 'href', downloadId });
      });
    } else if (Array.isArray(value)) value.forEach((child, index) => walk(child, `${path}[${index}]`));
    else if (value && typeof value === 'object') {
      if (value.kind === 'download') { slots.push({ path, shape: 'document', urlProp: 'url' }); return; }
      Object.entries(value).forEach(([key, child]) => walk(child, path ? `${path}.${key}` : key));
    }
  };
  walk(props, '');
  return slots;
}

export function documentSlotValue(props, slot) {
  const value = getPropAtPath(props, slot.path, slot.path);
  if (slot.shape !== 'downloadHtml') return value || {};
  const anchor = anchors(parseHtml(value || ''), slot.downloadId)[0];
  return {
    kind: 'download', url: anchor?.getAttribute('href') || '',
    filename: anchor?.getAttribute('download') || '',
    documentId: anchor?.getAttribute('data-document-id') || null,
    form: htmlSettings(anchor),
  };
}

export function updateDocumentSlot(props, slot, update) {
  const current = documentSlotValue(props, slot);
  const next = update(current);
  if (next === current) return props;
  if (slot.shape !== 'downloadHtml') return setBlockPropAtPath(props, slot.path, next);
  const template = parseHtml(getPropAtPath(props, slot.path, slot.path) || '');
  anchors(template, slot.downloadId).forEach((anchor) => {
    if (next.url) anchor.setAttribute('href', next.url); else anchor.removeAttribute('href');
    anchor.setAttribute('download', next.filename || '');
    anchor.setAttribute('data-document-id', next.documentId || '');
    anchor.setAttribute('data-download-form', JSON.stringify(next.form || {}));
    anchor.removeAttribute('target');
  });
  return setBlockPropAtPath(props, slot.path, template.innerHTML);
}
